import { createFileRoute, redirect } from '@tanstack/react-router'

import { AdminGlobalConfigPage } from '@/features/admin-global-config'
// Через `queries`, не через индекс фичи: лоадер вычисляется жадно, и индекс
// утянул бы страницу с формой в стартовый бандл.
import { globalConfigQuery } from '@/features/admin-global-config/queries'
import { PERMISSION_ADMIN } from '@/features/auth'

import { can } from '@/app/router/session'

export const Route = createFileRoute('/_auth/admin/global-config')({
  beforeLoad: ({ context }) => {
    if (!can(context, PERMISSION_ADMIN)) throw redirect({ to: '/' })
  },
  // Форма засеивается из данных на монтировании, так что скелет ей не нужен —
  // и роут, у которого нет ожидания, нечему сдвинуть.
  loader: ({ context }) => context.queryClient.ensureQueryData(globalConfigQuery()),
  component: AdminGlobalConfigPage,
})
